import React from 'react';

const LogoutV2 = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.0381 4.16675C11.0381 3.13153 10.1992 2.29195 9.16406 2.29175H4.16504C3.12969 2.29175 2.29004 3.1314 2.29004 4.16675V15.8308C2.29004 16.8662 3.12969 17.7058 4.16504 17.7058H9.16406C10.1992 17.7056 11.0381 16.866 11.0381 15.8308V13.3318H12.2881V15.8308C12.2881 17.5563 10.8895 18.9546 9.16406 18.9548H4.16504C2.43946 18.9548 1.04004 17.5564 1.04004 15.8308V4.16675C1.04004 2.44117 2.43946 1.04175 4.16504 1.04175H9.16406C10.8895 1.04195 12.2881 2.4413 12.2881 4.16675V6.66577H11.0381V4.16675ZM17.0241 9.37365H7.50041V10.6237H17.0239L14.5561 13.0914L15.44 13.9753L18.9748 10.4405C19.2188 10.1964 19.2188 9.80063 18.9748 9.55659L15.44 6.02175L14.5561 6.90563L17.0241 9.37365Z",
      fill: "white"
    }
  )
);

export { LogoutV2 };
//# sourceMappingURL=LogoutV2.js.map
